"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { filterOptionsByLabel } from './utils.mjs';

class ReferenceRecordsOptionsFactory {
  constructor(params) {
    this.params = params;
  }
  async getOptions({
    input
  }) {
    return this.getOptionsSync({ input });
  }
  getOptionsSync({ input }) {
    const options = [];
    if (this.params.schema.referenceRecords && Array.isArray(this.params.schema.referenceRecords)) {
      this.params.schema.referenceRecords.map((record) => {
        if (typeof record == "object" && record.id !== void 0) {
          options.push({
            label: record.name ?? record.id,
            value: record.id,
            iconType: SvgIconType.ListOption
          });
        }
      });
    }
    const filteredOptions = filterOptionsByLabel(options, input);
    if (filteredOptions.length > 0) {
      return [
        {
          label: "Possible Values",
          isSection: true,
          iconUri: this.params.iconUri
        },
        ...filteredOptions
      ];
    } else {
      return [];
    }
  }
}

export { ReferenceRecordsOptionsFactory };
